import { AUTOMATION_STUDIO_LOGIN_EXAMPLE } from '../../content';
import styles from '../../../../styles/automationStudio/emptyPanel.module.scss';

export default function ExampleChip({ onTryExample }) {
    const example = AUTOMATION_STUDIO_LOGIN_EXAMPLE;
    const examplePreview = example.instructions
        .map((inst, index) => `${index + 1}. ${inst.text}`)
        .join(' ');
    const ExampleIcon = example.icon;

    return (
        <button
            type="button"
            className={styles.exampleChip}
            onClick={onTryExample}
        >
            <span className={styles.exampleChipIconWrap}>
                <ExampleIcon className={styles.exampleChipIcon} aria-hidden="true" />
            </span>
            <span className={styles.exampleChipText}>
                <span className={styles.exampleChipLabel}>{example.label}</span>
                <span className={styles.exampleChipPreview}>{examplePreview}</span>
            </span>
        </button>
    );
}
